import { offerDataSelector } from './offerDataSelector';
import { IState } from '../../store';

export const selectSpecialProject = (state: IState) => {
  const offerData = offerDataSelector(state);

  return offerData.specialProject;
};
